import '../../CSS/private/Form.css';
import FormDetails from './FormDetails';

function FormInput(props)
{
  const value = props.value;
  const setValue = props.setValue;
  const placeholder = props.placeholder;
  const type = props.type;

  const formDetails = <FormDetails required={props.required} title={props.title} description={props.description} />

  return (
    <div className='slp-form slp-form-input'>
      {formDetails}
      <input type={type} placeholder={placeholder} defaultValue={value} onChange={(e) => {
        var x = e.target.value;
        if(props.lowercase) x = x.toLowerCase();
        if(props.trim) x = x.trim();
        setValue(x)
      }} disabled={props.disabled} />
    </div>
  )
}

export default FormInput;